const network = process.env.NEXT_PUBLIC_CHAINFLIP_NETWORK;
export const isTestnet = network !== 'mainnet';
export const isPublicNetwork = network === 'mainnet' || network === 'perseverance';
export const isSudo =
  typeof window !== 'undefined' && Boolean(new URLSearchParams(window.location.search).get('sudo'));
export const isLendingEnabled = !isPublicNetwork || isSudo; // TODO(CHP): remove flag after release
